import PropTypes from 'prop-types'
import React from 'react'
import { GoogleMapLoader, GoogleMap, Marker, KmlLayer } from 'react-google-maps'
import { FormattedMessage } from 'react-intl'
import Loader from 'components/util/Loader'
import styles from './_routeMap.css'

export const RouteMap = (props) => {
  const {
    center,
    markers,
    kmlLink,
    searchLoading,
    onMapLoad,
  } = props

  let kmlNode = null

  if (kmlLink) {
    const kmlObj = { url: kmlLink }
    kmlNode = <KmlLayer {...kmlObj} />
  }

  return (
    <div className={styles.mapContainer}>
      <GoogleMapLoader
        containerElement={<div className={styles.mapContainer} />}
        googleMapElement={
          <GoogleMap
            ref={onMapLoad}
            defaultZoom={10}
            center={center}
            options={{
              gestureHandling: 'cooperative',
              streetViewControl: false,
              mapTypeControl: true,
              mapTypeControlOptions: {
                style: window.google.maps.MapTypeControlStyle.DROPDOWN_MENU,
              },
              zoomControlOptions: {
                style: window.google.maps.ZoomControlStyle.LARGE,
              },
              overviewMapControl: true,
              mapTypeId: window.google.maps.MapTypeId.ROADMAP,
            }}>
            {markers.map((marker, i) => <Marker {...marker} key={i} />)}
            {kmlNode}
          </GoogleMap>
        } />
      {searchLoading ?
        <div className={styles.mapLoadingOverlay}>
          <div className={styles.mapLoadingContent}>
            <div className={styles.mapLoadingText}>
              <FormattedMessage
                id='routesearch.map.loadingtext'
                defaultMessage='Searching Routes...' />
            </div>
            <Loader type='ios' height={40} width={40} />
          </div>
        </div> : null}
    </div>
  )
}

RouteMap.propTypes = {
  onMapLoad: PropTypes.func,
  center: PropTypes.shape({
    lat: PropTypes.number,
    lng: PropTypes.number,
  }),
  markers: PropTypes.array,
  kmlLink: PropTypes.string,
  searchLoading: PropTypes.bool,
}



// WEBPACK FOOTER //
// ./src/components/routes/search/map/RouteMap.jsx